const routes = [
  {
    path: '*',
    redirect: '/error',
  },
  {
    path: '/',
    component: () =>
      import('../../src/pages/welcome'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/welcome',
    name: 'welcome',
    component: () =>
      import('../../src/pages/welcome'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/factorysupply/stcokGoods',
    name: 'stcokGoods',
    component: () =>
      import('../../src/pages/factorysupply/stcokGoods'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },

  {
    path: '/qrCode',
    name: 'qrCode',
    component: () =>
      import('../../src/pages/qrCode'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },

  {
    path: '/scanBarCode',
    name: 'scanBarCode',
    component: () =>
      import('../../src/pages/qrCode/scanBarCode.vue'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },
  {
    path: '/galleryDetails',
    name: 'galleryDetails',
    component: () =>
      import('../../src/pages/gallery/galleryDetails'),
  },
  {
    path: '/createGallery',
    name: 'createGallery',
    component: () =>
      import('../../src/pages/gallery/createGallery'),
  },
  {
    path: '/createGalleryStandard',
    name: 'createGalleryStandard',
    component: () =>
      import('../../src/pages/gallery/createGalleryStandard'),
  },
  {
    path: '/galleryOnlineGoods',
    name: 'galleryOnlineGoods',
    component: () =>
      import('../../src/pages/gallery/galleryOnlineGoods'),
  },
  {
    path: '/gallery/myGallery',
    name: '/gallery/myGallery',
    component: () =>
      import('../../src/pages/gallery/myGallery'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/gallery/galleryStandard',
    name: '/gallery/galleryStandard',
    component: () =>
      import('../../src/pages/gallery/galleryStandard'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/gallery/galleryHeatMap',
    name: '/gallery/galleryHeatMap',
    component: () =>
      import('../../src/pages/gallery/galleryHeatMap'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/stockProduct/single',
    name: '/stockProduct/single',
    component: () =>
      import('../../src/pages/stockProduct/single'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/inquiryOrders',
    name: '/inquiryOrders',
    component: () =>
      import('../../src/pages/inquiry_order/index'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/stockProduct/stockRemind',
    name: '/stockProduct/stockRemind',
    component: () =>
      import('../../src/pages/stockProduct/component/stockRemind'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },



  {
    path: '/stockProduct/combo',
    name: '/stockProduct/combo',
    component: () =>
      import('../../src/pages/stockProduct/combo'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/stockProduct/gift',
    name: '/stockProduct/gift',
    component: () =>
      import('../../src/pages/stockProduct/gift'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/stockProduct/storeTasks',
    name: '/stockProduct/storeTasks',
    component: () =>
      import('../../src/pages/stockProduct/storeTasks'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/onlineGoods',
    name: 'onlineGoods',
    component: () =>
      import('../../src/pages/stockProduct/component/onlineGoods'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/editor',
    name: 'editor',
    component: () =>
      import('../../src/pages/stockProduct/component/editor'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/bindGoods',
    name: 'bindGoods',
    component: () =>
      import('../../src/pages/stockProduct/component/bindGoods'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/stockProduct/productDetail',
    name: 'stockProduct',
    component: () =>
      import('../../src/pages/stockProduct/component/productDetail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },
  {
    path: '/stockProduct/productDetail',
    name: 'stockProduct',
    component: () =>
      import('../../src/pages/stockProduct/component/productDetail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },
  {
    path: '/tiktokShop',
    name: 'tiktokShop',
    component: () =>
      import('../../src/pages/stockProduct/component/publishTiktok'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },
  

  {
    path: '/transfer',
    name: 'transfer',
    component: () =>
      import('../../src/pages/transfer/transfer'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },
  {
    path: '/checktransfer',
    name: 'checktransfer',
    component: () =>
      import('../../src/pages/transfer/check'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

 

  {
    path: '/sellerorder',
    name: 'sellerorder',
    component: () =>
      import('../../src/pages/transfer/sellerorder'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },


  {
    path: '/factorysupply/inbound',
    name: '/factorysupply/inbound',
    component: () =>
      import('../../src/pages/factorysupply/inbound'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },

  {
    path: '/factorysupply/productShelves',
    name: '/factorysupply/productShelves',
    component: () =>
      import('../../src/pages/factorysupply/productShelves'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/factorysupply/createpurchasing',
    name: 'createpurchasing',
    component: () =>
      import('../../src/pages/factorysupply/createpurchasing'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/factorysupply/productLibrary',
    name: 'productLibrary',
    component: () =>
      import('../pages/factorysupply/productLibrary.vue'),meta:{requiresAuth:false,keepAlive:true,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
    path: '/pendingtrial',
    name: 'pendingtrial',
    component: () =>
      import('../pages/userstoreitems/components/pendingtrial'),
  },
  {
    path: '/factorysupply/manuallycreate',
    name: 'manuallycreate',
    component: () =>
      import('../pages/factorysupply/manuallycreate.vue'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  {
        path: '/agent',
        name: 'agent',
        component: () => import('../pages/userstoreitems/components/agent'),
        children:[
          {path:'/agent/hasAgentDetail',component:() => import('../pages/userstoreitems/components/hasAgentDetail'),meta:{requiresAuth:true,keepAlive:false} },
          {path:'/agent/agents',component:() => import('../components/warehouse/agents'),meta:{requiresAuth:true,keepAlive:false} },
          {path:'/agent/priceControl',component:() => import('../components/warehouse/priceControl'),meta:{requiresAuth:true,keepAlive:false} },
          ]

         
      },
  {
        path: '/factorysupply/editproducts',
        name: 'editproducts',
        component: () =>
          import('../pages/factorysupply/editproducts.vue'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
      
      },
  {
    path: '/factorysupply/stcokGoods',
    name: '/factorysupply/stcokGoods',
    component: () =>
      import('../../src/pages/factorysupply/stcokGoods'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
	
  },
  
 

  {
    path: '/stockProduct/productDetail',
    name: '/stockProduct/productDetail',
    component: () =>
      import('../../src/pages/stockProduct/component/productDetail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },

  {
    path: '/stockProduct/template',
    name: '/stockProduct/template',
    component: () =>
      import('../../src/pages/stockProduct/component/template'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },

 
  



  {
    path: '/mh5/distributionStore',
    name: 'distributionStore',
    component: () =>
      import('../../src/pages/h5/distributionStore'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },

  {
    path: '/mh5/productDetail',
    name: 'productDetail',
    component: () =>
      import('../../src/pages/h5/components/productDetail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },

  {
    path: '/mh5/pcdetail',
    name: 'pcdetail',
    component: () =>
      import('../../src/pages/h5/components/PC_detail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },

  {
    path: '/mh5/detail',
    name: 'detail',
    component: () =>
      import('../../src/pages/h5/components/detail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },

  {
    path: '/mh5/hasAgent',
    name: 'hasAgent',
    component: () =>
      import('../../src/pages/h5/hasAgent'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },



  {
    path: '/mh5/login',
    name: 'login',
    component: () =>
      import('../../src/pages/h5/components/login'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },

  

  {
    path: '/mh5/register',
    name: 'register',
    component: () =>
      import('../../src/pages/h5/components/register'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },
  {
    path: '/mh5/pageOne',
    name: 'pageOne',
    component: () =>
      import('../../src/pages/h5/components/pageOne'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
	
  },
  {
    path: '/mh5/personal',
    name: 'person',
    component: () =>
      import('../../src/pages/h5/person'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
  },
  {
    path: '/mh5/index',
    name: 'index',
    component: () =>
      import('../../src/pages/h5/index'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
  },

  {
    path: '/home',
    name: 'home',
    component: () =>
       import('../pages/home/home'),
  	 meta:{
		 requiresAuth:true,
		 keepAlive:true
		} 
  },
  {
    path: '/home/en',
    name: 'homeEn',
    component: () =>
       import('../pages/home/homeEn'),
  	 meta:{
		 requiresAuth:true,
		 keepAlive:true
		} 
  },

  {
    path: '/storehome',
    name: 'home',
    component: () =>
       import('../pages/home/storehome'),
  	 meta:{
		 requiresAuth:true,
		 keepAlive:true
		} 
  },


  {
    path: '/claimOrder',
    name: 'claimOrder',
    component: () =>
       import('../pages/shopaccess/claimOrder'),
	 meta:{requiresAuth:true,keepAlive:true} 
  },

  {
    path: '/index',
    name: 'index',
    component: () =>
       import('../pages/shopaccess/shopaccess'),
	 meta:{requiresAuth:true,keepAlive:true} 
  },


  {
    path: '/sellerManagement',
    name: 'sellerManagement',
    component: () =>
       import('../pages/shopaccess/sellerManagement'),
	 meta:{requiresAuth:true,keepAlive:true} 
  },

  {
    path: '/barCode',
    name: 'barCode',
    component: () =>
      import('../components/barCode2'),
  },
  {
    path: '/productList',
    name: 'productList',
    component: () =>
      import('../components/warehouse/productList'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () =>
      import('../components/privacy'),
  },

  {
    path: '/purchaseBarcode',
    name: 'purchaseBarcode',
    component: () =>
      import('../components/purchaseBarcode'),
  },

  {
    path: '/shopifyAuthorzation',
    name: 'shopifyAuthorzation',
    component: () =>
      import('../components/shopifyAuthorzation'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true}
  },
  {
    path: '/privacystatement',
    name: 'privacystatement',
    component: () =>
      import('../components/privacystatement'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true}
  },
  
  {
    path: '/error',
    name: 'error',
    component: () =>
      import('../components/error'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true}
  },


  {
    path: '/remoteDXSaccount',
    name: 'remoteDXSaccount',
    component: () =>
      import('../components/remoteDXSaccount'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true}
  },
  {
    path: '/precistDelivery',
    name: 'precistDelivery',
    component: () =>
      import('../pages/allOrders/processed/precistDelivery'),
  },

  {
    path: '/mygoodsTab',
    redirect: '/mygoods/shopee',
    name: 'mygoodsTab',
    component: () => import('../pages/mygoods/mygoodsTab'),
    children:[
    {path:'/mygoods/shopee',component:() => import('../pages/mygoods/mygoods'),meta:{requiresAuth:true,keepAlive:false} },
    {path:'/mygoods/lazada',component:() =>import('../pages/mygoods/lazadamygoods'),meta:{requiresAuth:true,keepAlive:false} },
    ]
  	
  },


  {
    path: '/binditemsTab',
    redirect: '/binditems/shopee',
    name: 'binditemsTab',
    component: () => import('../pages/mygoods/binditemsTab'),
    children:[
    {path:'/binditems/shopee',component: () => import('../pages/mygoods/binditems'),meta:{requiresAuth:true,keepAlive:false} },
    {path:'/binditems/lazada',component:() =>import('../pages/mygoods/lazadabinditems'),meta:{requiresAuth:true,keepAlive:false} },
    ]
  	
  },


  {
    path: '/customer',
    name: 'customer',
    component: () =>
      import('../pages/customer/customer'),
  },

  {
    path: '/ReturnOrders',
    name: 'ReturnOrders',
    component: () =>
      import('../pages/allOrders/returnorder/ReturnOrders'),
  	meta:{requiresAuth:true,keepAlive:false} 
  },
  {
    path: '/complaint',
    name: 'complaint',
    component: () =>
      import('../pages/allOrders/complaint/complaintOrder'),
  	meta:{requiresAuth:true,keepAlive:false} 
  },

  {
    path: '/complaintStore',
    name: 'complaintStore',
    component: () =>
      import('../pages/allOrders/complaint/complaintStore'),
  	meta:{requiresAuth:true,keepAlive:false} 
  },
  {
    path: '/allOrders',
    name: 'allOrders',
    component: () => import('../pages/allOrders/allorder/orders'),meta:{requiresAuth:true,keepAlive:false} 
  	
  },
  {
    path: '/bandigoods',
    name: 'bandigoods',
    component: () =>
      import('../pages/bandigoods/bandigoods'),
	  meta:{requiresAuth:true,keepAlive:false} 
  },
  {
    path: '/loginPage',
    name: 'loginPage',
    component: () =>
      import('../components/loginPage'),
  },
  {
    path: '/watermark',
    name: 'watermark',
    component: () =>
      import('../components/watermark'),
  },

  

  {
    path: '/promotional',
    name: 'promotional',
    component: () =>
      import('../components/promotional'),
  },

  {
    path: '/login',
    name: 'loginPage',
    component: () =>
      import('../components/login'),
  },

  {
    path: '/loginRmote',
    name: 'loginRmote',
    component: () =>
      import('../components/loginRmote'),
  },
  {
    path: '/loginToken',
    name: 'loginToken',
    component: () =>
      import('../components/loginToken'),
	
  },
  // {
  //   path: '/unprocessedorder',
	// redirect: '/unprocessedorder/shopee',
  //   name: 'unprocessedorder',
  //   component: () => import('../pages/allOrders/unprocessedorder/unprocessedorder'),
	
	// children:[
		
	// 	{path:'shopee',component: () => import('../pages/allOrders/unprocessedorder/orderPrint'),meta:{requiresAuth:true,keepAlive:true} },
	// 	{path:'lazada',component:() =>import('../pages/allOrders/unprocessedorder/lazadaorderprint'),meta:{requiresAuth:true,keepAlive:true} },
	// ]
  	
  // },
  // {
  //   path: '/unprocessedorder/orderprint',
  //   name: 'orderprint',
  //   component: () => import('../pages/allOrders/unprocessedorder/shoppeeunprocessedorder'),
	//  meta:{requiresAuth:false,keepAlive:false} 
  // },
  {
    path: '/group',
    name: 'group',
    component: () => import('../pages/group/group'),
  	
  	
  },
  
  
  {
    path: '/processedOrder',
    name: 'processedOrder',
    component: () =>
      import('../pages/allOrders/processed/processedOrder'),
  	
  },

  {
    path: '/processedSeller',
    name: 'processedSeller',
    component: () =>
      import('../pages/allOrders/processed/processedSeller'),
  	
  },
  {
    path: '/processed',
    name: 'processed',
  	redirect: '/processed/processedshopee',
    component: () => import('../pages/allOrders/processed/processedTab'),
  	children:[
  	{path:'processedshopee',component: () => import('../pages/allOrders/processed/processed'),meta:{requiresAuth:true,keepAlive:true} },
  	{path:'processedlazada',component:() =>import('../pages/allOrders/processed/lazadaprocessed'),meta:{requiresAuth:true,keepAlive:true} },
  	]
   
  },
  {
    path: '/storepurchase',
    name: 'storepurchase',
    component: () =>
      import('../pages/storepurchase/storepurchase'),
  	
  },

  {
    path: '/inventory',
    name: 'inventory',
    component: () =>
      import('../pages/storepurchase/inventory'),
  	
  },
  {
    path: '/orderAndpicklist',
    name: 'orderAndpicklist',
    component: () =>
      import('../components/orderAndpicklist'),
  	
  },

  {
    path: '/sellerpurchase',
    name: 'sellerpurchase',
    component: () =>
      import('../pages/sellerpurchase/sellerpurchase'),
  },
  {
    path: '/userFbsrule',
    name: 'userFbsrule',
    component: () =>
      import('../pages/sellerpurchase/userFbsrule'),
  },
  {
    path: '/reviewOrders',
    name: 'reviewOrders',
    component: () =>import('../pages/allOrders/pendingorder/reviewOrders'),meta:{requiresAuth:true,keepAlive:true} 

  },
  {
    path: '/pendingoreder',
    name: 'pendingoreder',
    component: () =>import('../pages/allOrders/pendingorder/shopeePending'),meta:{requiresAuth:true,keepAlive:true} 

  },
  {
    path: '/changeOrderInfo',
    name: 'changeOrderInfo',
    component: () =>import('../pages/allOrders/pendingorder/components/changeOrderInfo'),meta:{requiresAuth:true,keepAlive:false} 

  },
  {
    path: '/createNewOrder',
    name: 'createNewOrder',
    component: () =>import('../pages/allOrders/pendingorder/components/createNewOrder'),meta:{requiresAuth:true,keepAlive:false} 

  },
 {
    path: '/registor',
    name: 'registor',
    component: () =>
      import('../components/registor'),
	
  },
  {
    path: '/userRegistor',
    name: 'userRegistor',
    component: () =>
      import('../components/userRegistor'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true} 
	
  },
  {
    path: '/problemorder',
    name: 'problemorder',
    component: () =>
      import('../pages/allOrders/problemorder/problemorder'),
  },



  {
    path: '/notHandle',
    name: 'notHandle',
    component: () =>
      import('../pages/allOrders/unprocessedorder/notHandle'),
  },
  
  {
    path: '/storePendingOrder',
    name: 'storePendingOrder',
    component: () =>
      import('../pages/allOrders/unprocessedorder/storePendingOrder'),
  },



  {
    path: '/productPicklist',
    name: 'productPicklist',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productPicklist'),
  },
  {
    path: '/productStockling',
    name: 'productStockling',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productStockling'),
  },

  {
    path: '/productAndPicklist',
    name: 'productAndPicklist',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productAndPicklist'),
      meta:{
        showHeaderAside:true,hideTopBar:true
      }
  },
  {
    path: '/productWaybill',
    name: 'productWaybill',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productWaybill'),
      meta:{
        showHeaderAside:true,hideTopBar:true
      }
  },

  {
    path: '/selfbuiltorder',
    name: 'selfbuiltorder',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/selfbuiltorder'),
      meta:{
        showHeaderAside:true,hideTopBar:true
      }
  },

  {
    path: '/productAndPicklistCopy',
    name: 'productAndPicklistCopy',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productAndPicklistCopy'),
  },
  {
    path: '/purchuseList',
    name: 'purchuseList',
    component: () =>
      import('../pages/factorysupply/purchuseList.vue'),
    meta:{
      showHeaderAside:true,hideTopBar:true
    }
  },
  {
    path: '/productPickSheetMerge',
    name: 'productPickSheetMerge',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productPickSheetMerge'),meta:{ showHeaderAside:true,hideTopBar:true }
  },
  {
    path: '/productPickSheet',
    name: 'productPickSheet',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productPickSheet'),meta:{ showHeaderAside:true,hideTopBar:true }
  },
  {
    path: '/productExpressSheet',
    name: 'productExpressSheet',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productExpressSheet'),meta:{ showHeaderAside:true,hideTopBar:true }
  },
  {
    path: '/vnprintPage',
    name: 'vnprintPage',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/vnprintPage'),meta:{ showHeaderAside:true,hideTopBar:true }
  },
  {
    path: '/sellertest',
    name: 'sellertest',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/sellertest'),meta:{ showHeaderAside:true,hideTopBar:true }
  },
  {
    path: '/productLazada',
    name: 'productLazada',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productLazada'),meta:{ showHeaderAside:true,hideTopBar:true }
  },

  {
    path: '/productLazadaPicklist',
    name: 'productLazadaPicklist',
    component: () =>
      import('../pages/allOrders/unprocessedorder/components/productLazadaPicklist'),meta:{ showHeaderAside:true,hideTopBar:true }
  },


  {
    path: '/distrustOrder',
    name: 'distrustOrder',
    component: () =>
      import('../pages/allOrders/problemorder/distrustOrder'),
  },
  {
    path: '/signOrder',
    name: 'signOrder',
    component: () =>
      import('../components/signOrder'),
  },
  // {
  //   path: '/sealpage',
  //   name: 'sealpage',
  //   component: () =>
  //     import('../components/print'),
  // },
  {
    path: '/userStoreItems',
    redirect: '/userStoreItems/products',
    name: 'userStoreItems',
    component: () =>import('../pages/userstoreitems/overseas/userstoreitemsTab'),
    children:[
        {path:'/userStoreItems/products',component: () => import('../pages/userstoreitems/overseas/userstoreitemsCopy'),meta:{requiresAuth:false,keepAlive:false} },
        {path:'/userStoreItems/accessories',component:() =>import('../pages/userstoreitems/overseas/accessories'),meta:{requiresAuth:false,keepAlive:false} },
        {path:'/userStoreItems/gift',component:() =>import('../pages/userstoreitems/overseas/gift'),meta:{requiresAuth:false,keepAlive:false} },
      ]
  },


  {
    path: '/storeManagement',
    redirect: '/storeManagement/single',
    name: 'storeManagement',
    component: () =>import('../pages/storepurchase/tab'),
    children:[
        {path:'/storeManagement/single',component: () => import('../pages/storepurchase/single'),meta:{requiresAuth:false,keepAlive:false} },
        {path:'/storeManagement/combination',component:() =>import('../pages/storepurchase/combination'),meta:{requiresAuth:false,keepAlive:false} },
        {path:'/storeManagement/gift',component:() =>import('../pages/storepurchase/gift'),meta:{requiresAuth:false,keepAlive:false} },
      ]
  },

  {
    path: '/alliance',
    redirect: '/alliance/singleGoods',
    name: 'alliance',
    component: () =>import('../pages/userstoreitems/alliance/tab'),
    children:[
        {path:'/alliance/singleGoods',component: () => import('../pages/userstoreitems/alliance/singeGoods'),meta:{requiresAuth:false,keepAlive:false} },
        {path:'/alliance/combination',component:() =>import('../pages/userstoreitems/alliance/combination'),meta:{requiresAuth:false,keepAlive:false} },
      ]
  },

  // {
  //   path: '/publicGoods',
  //   name: 'publicGoods',
  //   component: () => import('../pages/userstoreitems/distribution/community'),meta:{requiresAuth:false,keepAlive:true}  
  // },
  {
    path: '/publicGoods',
    name: 'publicGoods',
    component: () => import('../pages/userstoreitems/distribution/publicGoods'),meta:{requiresAuth:false,keepAlive:true}  
  },

  {
    path: '/video_material',
    name: 'video_material',
    component: () => import('../pages/userstoreitems/distribution/components/video_material.vue'),meta:{requiresAuth:false,keepAlive:true}  
  },

  {
    path: '/myselfproduct',
    name: 'myselfproduct',
    component: () => import('../pages/userstoreitems/distribution/myselfproduct'),meta:{requiresAuth:false,keepAlive:true},
    children:[
      {path:'/myselfproduct/goods',component: () => import('../pages/userstoreitems/distribution/components/myselfproduct'),meta:{requiresAuth:false,keepAlive:true} },
      {path:'/myselfproduct/order',component: () => import('../pages/userstoreitems/distribution/components/orders'),meta:{requiresAuth:false,keepAlive:true} },
      {path:'/myselfproduct/SampleApplication',component: () => import('../pages/userstoreitems/distribution/components/SampleApplication'),meta:{requiresAuth:false,keepAlive:true} },
      {path:'/myselfproduct/statistics',component: () => import('../pages/userstoreitems/distribution/components/statistics'),meta:{requiresAuth:false,keepAlive:true} },
      
    ]
  },

  {
    path: '/FreeSamples',
    name: 'FreeSamples',
    component: () => import('../pages/userstoreitems/distribution/FreeSamples'),meta:{requiresAuth:false,keepAlive:false}  
  },
  {
    path: '/SampleApplication',
    name: 'SampleApplication',
    component: () => import('../pages/userstoreitems/distribution/SampleApplication'),meta:{requiresAuth:false,keepAlive:true}  
  },
  {
    path: '/hasAgent',
    name: 'hasAgent',
    component: () => import('../pages/userstoreitems/distribution/hasAgent'),meta:{requiresAuth:false,keepAlive:true}  
  },





  {
    path: '/iddstation',
    name: 'iddstation',
    component:() =>import('../pages/userstoreitems/distribution/iddstation'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false,hideTopBar:true} 
  },
  {
    path: '/servicechat',
    name: 'servicechat',
    component:() =>import('../pages/userstoreitems/distribution/servicechat'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
  },
  {
    path: '/Detail',
    name: 'Detail',
    component:() =>import('../pages/userstoreitems/distribution/mobile/Detail'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
  },
  {
    path: '/loginDetail',
    name: 'loginDetail',
    component:() =>import('../pages/userstoreitems/distribution/mobile/login'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
  },

  {
    path: '/distributionOrder',
    name: 'distributionOrder',
    component:() =>import('../components/distributionOrder'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:true,hideTopBar:true} 
  },


  {
    path: '/PurchaseStorage',
    name: 'PurchaseStorage',
    component: () =>
      import('../pages/userstoreitems/purchaseStorage'),
  },

  {
    path: '/overseaProduct',
    name: 'overseaProduct',
    component: () =>
      import('../pages/userstoreitems/components/overseaProduct'),
  },

  {
    path: '/storeItemDetail',
    name: 'storeItemDetail',
    component: () =>
      import('../pages/userstoreitems/components/storeItemDetail'),
  },

  {
    path: '/hasAgentDetail',
    name: 'hasAgentDetail',
    component: () =>
      import('../pages/userstoreitems/components/hasAgentDetail'),
  },

  {
    path: '/saveFielf',
    name: 'saveFielf',
    component: () =>
      import('../pages/userstoreitems/components/saveFielf'),
  },


  {
    path: '/productModel',
    name: 'productModel',
    component: () =>
      import('../pages/userstoreitems/components/productionModel'),
  },

  {
    path: '/publishLazada',
    name: 'publishLazada',
    component: () =>
      import('../pages/userstoreitems/components/publishLazada'),
  },
  {
    path: '/publishTikTok',
    name: 'publishTikTok',
    component: () =>
      import('../pages/userstoreitems/components/publishTikTok'),
  },
  {
    path: '/publishTEMU',
    name: 'publishTEMU',
    component: () =>
      import('../pages/userstoreitems/components/publishTEMU'),
  },
  {
    path: '/massPublishTikTok',
    name: 'massPublishTikTok',
    component: () =>
      import('../pages/userstoreitems/distribution/batch-Release-TTS'),
  },
  {
    path: '/publishShopee',
    name: 'publishShopee',
    component: () =>
      import('../pages/userstoreitems/components/publishShopee'),
  },

  {
    path: '/imageEdit',
    name: 'imageEdit',
    component: () =>
      import('../pages/userstoreitems/components/imageEdit'),
  },


  {
        path: '/pendingtrial',
        name: 'pendingtrial',
        component: () =>
          import('../pages/userstoreitems/components/pendingtrial'),
      },
  {
    path: '/createProduct',
    name: 'createProduct',
    component: () =>
      import('../pages/userstoreitems/components/createProduct'),
  },
  {
        path: '/purchuseListcart',
        name: 'purchuseListcart',
        component: () =>
          import('../pages/factorysupply/purchuseListcart.vue'),
        meta:{
      showHeaderAside:true,hideTopBar:true
    }
      },
  {
    path: '/onlineProduct',
    name: 'onlineProduct',
    component: () =>
      import('../pages/userstoreitems/components/onlineProduct'),
  },
  {
    path: '/templateManagement',
    name: 'templateManagement',
    component: () =>
      import('../pages/userstoreitems/components/templateManagement'),
  },

  {
    path: '/collection',
    name: 'collection',
    component: () =>
      import('../pages/userstoreitems/components/collection'),
  },

  {
    path: '/templateEditor',
    name: 'templateEditor',
    component: () =>
      import('../pages/userstoreitems/components/templateEditor'),
  },

  {
    path: '/purchaseProduct',
    name: 'purchaseProduct',
    component: () =>
      import('../pages/purchaseProduct/purchaseProduct'),
  },

  {
    path: '/purchaseDetail',
    name: 'purchaseDetail',
    component: () =>
      import('../pages/purchaseProduct/purchaseDetail'),
  },
  {
    path: '/changeCost',
    name: 'changeCost',
    component: () =>
      import('../pages/purchaseProduct/changeCost'),
  },
  {
    path: '/godownentry',
    name: 'godownentry',
    component: () =>
      import('../pages/godownentry/godownentry'),
  },
  {
    path: '/check',
    name: 'check',
    component: () =>
      import('../pages/godownentry/check'),
  },
  
  {
    path: '/scanIntoStoreage',
    name: 'scanIntoStoreage',
    component: () =>
      import('../pages/godownentry/scanIntoStoreage'),meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false} 
  },

  {
    path: '/binditems',
    name: 'binditems',
    component: () =>
      import('../pages/mygoods/binditems'),
	  
  },
  {
    path: '/personal',
    name: 'personal',
    component: () =>import('../pages/personal/personal'),
	children:[
		{
		  path: '/personal',
		  redirect: '/personal-account',
			
		},
	{path:'/personal-info',component:() =>import('../pages/personal/info')},
	{path:'/personal-account',component:() =>import('../pages/personal/account'),},
  {path:'/personal-address',component:() =>import('../pages/personal/address'),},
	]
     
  },

  {
    path: '/addGoods',
    name: 'addGoods',
    component: () =>
      import('../components/addGoods'),
      meta:{requiresAuth:false,keepAlive:false,showHeaderAside:false} 
  },

  {
    path: '/addNewGoods',
    name: 'addNewGoods',
    component: () =>
      import('../components/addNewGoods'),
      meta:{requiresAuth:false,keepAlive:true,showHeaderAside:false} 
  },
  
  {
    path: '/recharge',
    name: 'recharge',
    component: () =>
      import('../pages/recharge/recharge'),
  	  
  },

  {
    path: '/erpRecharge',
    name: 'erpRecharge',
    component: () =>
      import('../pages/recharge/erpRecharge'),
  	  
  },
  {
    path: '/localStoreRecharge',
    name: 'localStoreRecharge',
    component: () =>
      import('../pages/recharge/localStoreRecharge'),
  },

  {
    path: '/overseaRecharge',
    name: 'overseaRecharge',
    component: () =>
      import('../pages/recharge/overseaRecharge'),
  	  
  },


  {
    path: '/orderpage',
    name: 'orderpage',
    component: () =>
      import('../components/printorderpage'),
  	  
  },{
    path: '/newPage',
    name: 'newPage',
    component: () =>
      import('../components/newPage'),
  },{
    path: '/newPagePicklist',
    name: 'newPagePicklist',
    component: () =>
      import('../components/newPagePicklist'),
  },{
    path: '/registrationlink',
    name: 'registrationlink',
    component: () =>
      import('../components/registrationlink'),
  },
  {
    path: '/registorpage',
    name: 'registorpage',
    component: () =>
      import('../components/registorpage'),
  },{
    path: '/stockingList',
    name: 'stockingList',
    component: () =>
      import('../components/stockingList'),
  },{
    path: '/processedDetail',
    name: 'processedDetail',
    component: () => import('../pages/allOrders/processed/processedDetail'),
  },{
    path: '/distributionLog',
    name: 'distributionLog',
    component: () => import('../pages/allOrders/processed/distributionLog'),
  },{
    path: '/package',
    name: 'package',
    component: () => import('../pages/allOrders/processed/package'),
  },{
    path: '/scanPrint',
    name: 'scanPrint',
    component: () => import('../pages/allOrders/processed/scanPrint'),
  },
  {
    path: '/treemap',
    name: 'treemap',
    component: () =>
       import('../pages/treemap/treemap'),
  	 meta:{requiresAuth:true,keepAlive:true} 
  },{
    path: '/discountShopee',
    name: 'discountShopee',
    component: ()=>
        import('../pages/goodsOperations/discountShopee')

  },

  
  {
    path: '/remind',
    name: 'remind',
    component: () =>
        import('../pages/remind/remind'),
  },

  {
    path: '/remind/template',
    name: 'remind_template',
    component: () =>
        import('../pages/remind/remind_template'),
  },
  {
    path: '/chat',  
    name: 'chat',
    component: () =>
        import('../pages/chat/chat'),
    meta:{
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/districhat',
    name: 'districhat',
    component:() =>import('../pages/userstoreitems/distribution/districhat'),
    
  },

  {
    path: '/picture',
    name: 'picture',
    component: () =>
      import('../pages/picture/picture'),
      meta:{
        keepAlive: true // 需要被缓存
      }
  },

  {
    path: '/secondPicture',
    name: 'secondPicture',
    component: () =>
      import('../pages/picture/secondPicture'),
  },

  {
    path: '/userOrders',
    name: 'userOrders',
    component: () =>
      import('../pages/picture/userOrders'),
  },

  {
    path: '/lazadaStockList',
    name: 'lazadaStockList',
    component: () =>
      import('../components/lazadaStockList'),
  },
  {
    path: '/relevant',
    name: 'relevant',
    component: () =>
      import('../pages/picture/relevant'),
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: () =>
      import('../pages/customerService/customerService'),
  },
]

export default routes
